import { 
  Component,
  Input
}  from '@angular/core';

@Component({
  templateUrl: './icons.html'  
})
export class IconsComponent { 

    constructor() {
      this.IconClassItemsSource = 
      [
        {Name: 'icon-black'}, 
        {Name: 'icon-white'}, 
        {Name: 'icon-green'},
        {Name: 'icon-gray'},
        {Name: 'icon-red'},
        {Name: 'icon-blue'}, 
        {Name: 'icon-yellow'}, 
        {Name: 'icon-orange'},
        {Name: 'icon-purple'}
      ];

      this.SelectedIconClass = this.IconClassItemsSource[0];

      this.IconSizeItemsSource = 
      [
        {Item: 0.75},
        {Item: 1},
        {Item: 2},
        {Item: 3}, 
        {Item: 4},
        {Item: 5}, 
        {Item: 6}, 
        {Item: 7}, 
        {Item: 8}, 
        {Item: 9}, 
        {Item: 10}
      ];

      this.SelectedIconSize = this.IconSizeItemsSource[1];

      this.BackgroundItemsSource = 
      [
        {Name: 'icon-background-white'},
        {Name: 'icon-background-black'}, 
        {Name: 'icon-background-gray'}
      ];

      this.SelectedBackground = this.BackgroundItemsSource[0];
    }

    @Input() get IconClass() {
      if (this.SelectedIconClass)
        return this.SelectedIconClass.Name;
    }
   
    @Input() get IconSize() {
      if (this.SelectedIconSize)
        return this.SelectedIconSize.Item;
    }

    @Input() get Background() {
      if (this.SelectedBackground)
        return this.SelectedBackground.Name;
    }

    public IconClassItemsSource;
    @Input() SelectedIconClass;

    public IconSizeItemsSource;
    @Input() SelectedIconSize;

    public BackgroundItemsSource;
    @Input() SelectedBackground;
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/icons/icons-component.ts